import { useMemo } from "react";

import { ListTile } from "@repo/core/components/layout/ListTile";
import { TileLabel } from "@repo/core/components/layout/ListTile/types";

import { FinancialServiceTileProps } from "./types";

export const FinancialServiceTile = ({
  id,
  title,
  isActive = false,
  onPress
}: FinancialServiceTileProps) => {
  const labels = useMemo(() => {
    return [
      new TileLabel({
        text: title || "",
        fontColor: "$textLight900",
        fontWeight: 600
      })
    ];
  }, [title]);

  return (
    <ListTile
      id={id.toString()}
      onPress={() => onPress?.(id)}
      labels={labels}
      isActive={isActive}
    />
  );
};
